import {CellZone, MockCell, MockPlace, MockState, MockWorker, PlaceState} from './types'

/* =========================================================================
   WMS · seed data — порт seed() из wms-prototype.html.
   Стеллажи A–C (склад), D (карантин), E (экспедиция), F (долгое хранение);
   7 сотрудников; часть грузов уже на хранении (сценарий выдачи), часть — на
   ТТЦ (сценарий приёмки).
   ========================================================================= */

function makeCells(): MockCell[] {
  const cells: MockCell[] = []
  const mk = (rack: string, sec: number, floor: number, type: CellZone) => {
    cells.push({code: `${rack}${sec}-${floor}`, rack, sec, floor, type, places: []})
  }
  ;['A', 'B', 'C'].forEach((r) => {
    for (let s = 1; s <= 6; s++) for (let f = 1; f <= 3; f++) mk(r, s, f, 'storage')
  })
  for (let s = 1; s <= 2; s++) for (let f = 1; f <= 2; f++) mk('D', s, f, 'quarantine')
  for (let s = 1; s <= 3; s++) for (let f = 1; f <= 2; f++) mk('E', s, f, 'expedition')
  for (let s = 1; s <= 2; s++) for (let f = 1; f <= 3; f++) mk('F', s, f, 'longterm')
  return cells
}

function makeWorkers(): MockWorker[] {
  return [
    {id: 'w0', name: 'Ирина Ким', role: 'dispatcher', barcode: 'W-1000', active: true},
    {id: 'w1', name: 'Азиз Рахимов', role: 'searcher', barcode: 'W-1001', active: true},
    {id: 'w2', name: 'Бахтиёр Усмонов', role: 'mover', barcode: 'W-1002', active: true},
    {id: 'w3', name: 'Дилшод Каримов', role: 'controller', barcode: 'W-1003', active: true},
    {id: 'w4', name: 'Санжар Тошев', role: 'picker', barcode: 'W-1004', active: true},
    {id: 'w5', name: 'Улугбек Норов', role: 'driver', barcode: 'W-1005', active: true},
    {id: 'w6', name: 'Зухра Мирзаева', role: 'manager', barcode: 'W-1006', active: true},
  ]
}

const PHONE: Record<string, string> = {
  '04417': '+998 90 123-45-67',
  '15120': '+998 91 234-56-78',
  '26033': '+998 93 345-67-89',
  '07781': '+998 94 456-78-90',
  '08090': '+998 97 567-89-01',
}

// 17-значный штрих код: превышает Number.MAX_SAFE_INTEGER, поэтому счётчик строковый.
const BC_PREFIX = '200005003012101'

export function seed(): MockState {
  const cells = makeCells()
  const workers = makeWorkers()
  const places: MockPlace[] = []
  let bcn = 0
  let pid = 0

  const addPlace = (
    order: string,
    client: string,
    code: string,
    weight: number,
    volume: number,
    pack: string,
    ttc: string,
    state: PlaceState,
    cell: string | null,
    goods?: string
  ): MockPlace => {
    const p: MockPlace = {
      id: 'p' + ++pid,
      barcode: BC_PREFIX + String(++bcn).padStart(2, '0'),
      order,
      client,
      code,
      phone: PHONE[code] || '',
      weight,
      volume,
      pack,
      ttc,
      goods: goods || 'Товар',
      state,
      cell: cell || null,
      pallet: null,
      requestId: null,
    }
    places.push(p)
    if (cell) {
      const c = cells.find((x) => x.code === cell)
      if (c) c.places.push(p.id)
    }
    return p
  }

  // Уже на хранении — сценарий выдачи.
  addPlace('GZ0000041', 'Отабек Юсупов', '04417', 34.5, 0.42, 'Коробка', 'A-2', 'in_cell', 'A1-1', 'Стеллаж металлический')
  addPlace('GZ0000041', 'Отабек Юсупов', '04417', 18.0, 0.2, 'Коробка', 'A-2', 'in_cell', 'A1-2', 'Стеллаж металлический · крепёж')
  addPlace('GZ0000042', 'Отабек Юсупов', '04417', 62.0, 0.88, 'Палет', 'A-3', 'in_cell', 'A2-1', 'Плитка керамическая')
  addPlace('GZ0000043', 'Нилуфар Азимова', '15120', 9.4, 0.11, 'Мешок', 'B-1', 'in_cell', 'B1-1', 'Текстиль · рулон')
  addPlace('GZ0000044', 'Нилуфар Азимова', '15120', 27.3, 0.35, 'Коробка', 'B-1', 'in_cell', 'B2-3', 'Посуда столовая')
  addPlace('GZ0000045', 'Жасур Холматов', '26033', 115.0, 1.6, 'Палет', 'B-4', 'in_cell', 'C1-1', 'Холодильник Beko')

  // Только что пришли на ТТЦ — сценарий приёмки.
  addPlace('GZ0000055', 'Дилноза Каримова', '07781', 41.2, 0.52, 'Коробка', 'K-9', 'at_ttc', null, 'Смеситель сантехнический · короб 1/2')
  addPlace('GZ0000055', 'Дилноза Каримова', '07781', 39.8, 0.5, 'Коробка', 'K-9', 'at_ttc', null, 'Смеситель сантехнический · короб 2/2')
  addPlace('GZ0000056', 'Дилноза Каримова', '07781', 73.5, 0.95, 'Палет', 'K-12', 'at_ttc', null, 'Ламинат · упаковка')
  addPlace('GZ0000057', 'Рустам Сафаров', '08090', 12.6, 0.16, 'Мешок', 'L-4', 'at_ttc', null, 'Фурнитура мебельная')
  addPlace('GZ0000058', 'Рустам Сафаров', '08090', 55.0, 0.7, 'Коробка', 'L-4', 'at_ttc', null, 'Кондиционер настенный')

  return {
    seq: {task: 4100, req: 610, inv: 12, pallet: 0},
    cells,
    workers,
    places,
    tasks: [],
    requests: [],
    inventories: [],
    moveLog: [],
    journal: [],
    norms: {},
    rates: {},
  }
}
